import { createFieldset } from './fieldset';

export default {
  title: 'Aggiungi Offerta',
  elements: [
    {
      type: 'createForm',
      config: {
        actions: {
          save: {
            endpoint: 'offers',
            method: 'POST'
          }
        },
        fieldsets: [createFieldset]
      }
    }
  ]
};
